module.exports = __webpack_public_path__ + "img/Picture12.286b9731.png";